import { Edit, useForm } from "@refinedev/antd";
import { useShow } from "@refinedev/core";
import { Form, Input, Spin, Switch, message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const InventoryEdit: React.FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    // Use useShow to fetch the data
    const { queryResult } = useShow({
        resource: "inventory",
        id,
        meta: {
            fields: [
                "id",
                "itemCode",
                "itemTypeCode",
                "itemClassificationCode",
                "itemName",
                "barcode",
                "additionalInformation",
                "isActive"
            ]
        }
    });

    const { data, isLoading } = queryResult;
    const record = data?.data;

    const { formProps, saveButtonProps, onFinish } = useForm({
        resource: "inventory",
        action: "edit",
        id,
        onMutationSuccess: () => {
            message.success("Inventory item updated successfully");
            navigate("/inventory");
        }
    });

    // Update loading state
    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading]);

    if (loading || !record) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                <Spin />
            </div>
        );
    }

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Form
                {...formProps}
                layout="vertical"
                initialValues={{
                    id: record.id,
                    itemCode: record.itemCode || "",
                    itemTypeCode: record.itemTypeCode || "",
                    itemClassificationCode: record.itemClassificationCode || "",
                    itemName: record.itemName || "",
                    barcode: record.barcode || "",
                    additionalInformation: record.additionalInformation || "",
                    isActive: record.isActive || false
                }}
            >
                <Form.Item
                    hidden
                    name="id"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Item Code"
                    name="itemCode"
                    rules={[{ required: true }]}
                >
                    <Input disabled />
                </Form.Item> 
                <Form.Item
                    label="HSCode"
                    name="itemClassificationCode"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Item Name"
                    name="itemName"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Item Description"
                    name="itemTypeCode"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Barcode"
                    name="barcode"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Active"
                    name="isActive"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Edit>
    );
}; 